import fetch from '../utils/fetch'

// 团批配置
export function settingParams(type, op, params) {
  return fetch({
    url: `/batch/setting_params?type=${type}&op=${op}`,
    method: 'post',
    params
  })
}

// 团批配置
export function getSetting(type) {
  return fetch({
    url: `/batch/get_setting?type=${type}`,
    method: 'get'
  })
}
// 添加团批商品
export function addBatchItems(params) {
  return fetch({
    url: `/batch/items`,
    method: 'post',
    params
  })
}

// 添加1元商品
export function addOneBuyGoods(params) {
  return fetch({
    url: `/oneBuy/items`,
    method: 'post',
    params
  })
}
// 1元商品列表
export function oneBuyGoodsList(params) {
  return fetch({
    url: `/oneBuy/items`,
    method: 'get',
    params
  })
}

// 1元商品设置限制
export function itemMinDeliveryNum(params) {
  return fetch({
    url: `/oneBuy/itemMinDeliveryNum`,
    method: 'post',
    params
  })
}
// 移除1元商品
export function deleteOneBuyGoods(itemid, params) {
  return fetch({
    url: `/oneBuy/item/` + itemid,
    method: 'delete',
    params
  })
}
// 团批商品列表
export function batchGoodsList(params) {
  return fetch({
    url: `/batch/lists`,
    method: 'get',
    params
  })
}
// 添加团批商品
export function addBatchGoods(params) {
  return fetch({
    url: `/batch/items`,
    method: 'post',
    params
  })
}
// 移除团批商品
export function deleteBatchGoods(itemid, params) {
  return fetch({
    url: `/batch/delete/` + itemid,
    method: 'post',
    params
  })
}
// 修改团批商品属性
export function updateBatchGoods(params) {
  return fetch({
    url: `/batch/update`,
    method: 'post',
    params
  })
}
